import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { figureLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy figure envelope — the **only** figure variant.
 * The widget model registers `params.type: ['zero']`, so the host factory
 * always copies `meta.type === 'zero'` onto the entity at creation time;
 * `type: z.literal('zero')` is therefore required here, exactly like the
 * button/video zero envelopes.
 */
export const figureLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('figure'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: figureLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
